import { useEffect, useState } from 'react'

import {
  fetchRemoteFileSize,
  formatFileSize
} from '@/api/models/requests/lib/requests.utils'

export const useRemoteFileSize = (fileLink?: string) => {
  const [fileSizeWithUnit, setFileSizeWithUnit] = useState('')

  useEffect(() => {
    setFileSizeWithUnit('')

    if (!fileLink) {
      return
    }

    let cancelled = false

    const loadFileSize = async () => {
      const size = await fetchRemoteFileSize(fileLink)

      if (!cancelled && size) {
        setFileSizeWithUnit(formatFileSize(size))
      }
    }

    loadFileSize()

    return () => {
      cancelled = true
    }
  }, [fileLink])

  return fileSizeWithUnit
}
